import validate from "/opt/render/project/src/node_modules/.pnpm/nuxt@3.16.1_@netlify+blobs@8.1.0_@parcel+watcher@2.5.1_@types+node@22.10.10_better-sqli_3de81192caaea88ba10c266c80226d94/node_modules/nuxt/dist/pages/runtime/validate.js";
import middleware_45global from "/opt/render/project/src/apps/refresh/middleware/middleware.global.ts";
import manifest_45route_45rule from "/opt/render/project/src/node_modules/.pnpm/nuxt@3.16.1_@netlify+blobs@8.1.0_@parcel+watcher@2.5.1_@types+node@22.10.10_better-sqli_3de81192caaea88ba10c266c80226d94/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  middleware_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}